module.exports = __webpack_public_path__ + "static/media/market.25d54302.png";